import React from 'react';
import { Form, Input, Button, Select } from 'antd';
import styles from '../ManageReportPage/ReportFilterForm/ReportFilterForm.scss';
import { ProblemReportLabels, ReportTypesLabels, ReportTypesValues, SUBCATEGORIES } from "../../../components/ContactButton/FeedbackForm";

const { Option } = Select;

const UserFeedbackFilterForm = ({ onSubmit, className, form }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form.getFieldsValue());
  };

  const handleReset = () => {
    form.resetFields();
    onSubmit({});
  };

  const category = form.getFieldValue("group")
  const subcategories = category ? SUBCATEGORIES[category] : undefined;

  return (
    <Form layout="inline" onSubmit={handleSubmit} className={`${styles.form} ${className}`}>
      <Form.Item>
        {form.getFieldDecorator('group')(
          <Select
            placeholder={"Kategorija"}
            className={styles.moduleDropdown}
          >
            <Option value={ReportTypesValues.problemReport}>{ReportTypesLabels[ReportTypesValues.problemReport]}</Option>
            <Option value={ReportTypesValues.improvementReport}>{ReportTypesLabels[ReportTypesValues.improvementReport]}</Option>
            <Option value={ReportTypesValues.rest}>{ReportTypesLabels[ReportTypesValues.rest]}</Option>

          </Select>
        )}
      </Form.Item>
      {subcategories && <Form.Item>
        {form.getFieldDecorator('subGroup')(
          <Select
            placeholder={"Potkategorija"}
            className={styles.moduleDropdown}
          >
            {subcategories.map((sub) => (
              <Option key={sub} value={sub}>{ProblemReportLabels[sub]}</Option>
            ))}

          </Select>
        )}
      </Form.Item>}
      <Form.Item>
        {form.getFieldDecorator('email')(
          <Input className={styles.textInput} placeholder="E-mail" style={{ width: 240 }} />
        )}
      </Form.Item>

      <Form.Item>
        <Button className={styles.control} type="primary" htmlType="submit">
          {"Traži"}
        </Button>
      </Form.Item>
      <Form.Item>
        <Button className={styles.control} onClick={handleReset}>
          {"Resetiraj"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Form.create()(UserFeedbackFilterForm);



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserFeedbackPage/UserFeedbackFilterForm.tsx